import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

export const StatementChart = ({ days  }: any) => {
    const [listDate, setListDate] = useState<any>([])
    const [chartData, setChartData] = useState<any>([])


    const options = {
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                    // forces step size to be 50 units
                    stepSize: 20,
                    offset: true
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
                text: 'Profit chart',
            },
        },
    };


    const labels = listDate;

    const data = {
        labels,
        datasets: [
            {
                fill: true,
                label: 'میزان سود ($)',
                data: chartData,
                borderColor: '#2563eb',
                backgroundColor: '#2160a442',
                tension: 0.4,
            },
        ],
    };

    useEffect(() => {
        if (days) {
            let list_date: any = []
            let list_chart: any = []
            for (let i of days) {
                list_date.push(i.date)
                list_chart.push(i.lastBalanceOfDay)
            }
            setListDate(list_date)
            setChartData(list_chart)

        }
    }, [days])

    return (
        <>
            <div className="w-full flex flex-col py-4 px-3 rounded-md bg-trade-50">
                <Line style={{ width: "100%" }} options={options} data={data} height={120} />
            </div>
        </>
    )
}